import { Phone, Mail, ArrowUpRight, Hammer } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "./Nav";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "Why TCB", href: "#why-tcb" },
  { label: "Free Quote", href: "#quote" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-ink-card/60">
      <div className="h-[3px] hazard-stripes" aria-hidden="true" />
      <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-16 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 bg-safety clip-notch-sm flex items-center justify-center">
                <Hammer className="w-5 h-5 text-ink" strokeWidth={2.5} />
              </span>
              <span className="font-display text-2xl uppercase tracking-wide text-bone">
                TCB <span className="text-safety">Properties</span>
              </span>
            </div>
            <p className="text-steel text-sm leading-relaxed mt-5 max-w-sm">
              Residential construction done right: remodels, decks, additions, fencing,
              roofing, tree services and handyman work. One local crew, one call.
            </p>
            <span className="inline-block mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-safety font-bold border border-safety/40 px-4 py-2">
              Licensed &amp; Insured
            </span>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-steel font-bold mb-5">Site</p>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/ /g, "-")}`} className="text-bone/80 hover:text-safety transition-colors text-sm font-medium">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-steel font-bold mb-5">Talk to us</p>
            <a href={PHONE_TEL} data-testid="footer-call-btn" className="flex items-center gap-3 group">
              <span className="w-10 h-10 border border-line group-hover:border-safety group-hover:bg-safety group-hover:text-ink transition-all duration-200 flex items-center justify-center">
                <Phone className="w-4 h-4 text-safety group-hover:text-ink transition-colors" strokeWidth={2.5} />
              </span>
              <span className="font-display text-2xl text-bone group-hover:text-safety transition-colors">{PHONE_DISPLAY}</span>
            </a>
            <a href="mailto:despinosa@tcbcctx.com" data-testid="footer-mail-btn" className="flex items-center gap-3 mt-5 group">
              <span className="w-10 h-10 border border-line group-hover:border-safety flex items-center justify-center">
                <Mail className="w-4 h-4 text-safety" strokeWidth={2.5} />
              </span>
              <span className="text-bone/80 group-hover:text-safety transition-colors text-sm font-medium">despinosa@tcbcctx.com</span>
            </a>
            <a
              href="#quote"
              data-testid="footer-quote-cta"
              className="inline-flex items-center gap-2 mt-8 font-mono text-xs uppercase tracking-[0.2em] text-safety font-bold hover:gap-3 transition-all duration-200"
            >
              Request a free quote <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
            </a>
          </div>
        </div>

        <div className="mt-16 select-none" aria-hidden="true">
          <p className="font-display uppercase leading-none text-outline text-[clamp(3rem,11vw,10rem)] tracking-tight whitespace-nowrap overflow-hidden">
            TCB Properties
          </p>
        </div>

        <div className="mt-10 pt-6 border-t border-line flex flex-col sm:flex-row justify-between gap-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-steel">© {new Date().getFullYear()} TCB Properties, LLC. All rights reserved.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-steel">Built to outlast the hype.</p>
        </div>
      </div>
    </footer>
  );
}
